// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2b61c330","977":"912de6d2"}[chunkId] + ".chunk.js";
};